{
  "version": 1,
  "asset_id": "4cf6ef8b-1b95-45ee-ba37-88bc984ea8a5",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/4cf6ef8b-1b95-45ee-ba37-88bc984ea8a5/property-tour-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/4cf6ef8b-1b95-45ee-ba37-88bc984ea8a5/property-tour-placeholder.jpg",
  "original_filename": "property-tour-placeholder.jpg",
  "size": 778936,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T14:57:00Z"
}
